import { message } from 'antd';
import { getMediaUrl } from '../config';
import axios from '../api';
import { getDownloadUrl } from './fileUrlHelper';

/**
 * 同步版本的下载函数（用于事件处理）
 * @param {Object} doc - 文档对象，包含 file_url 和 title 字段
 */
export const downloadFile = (doc) => {
  // 立即执行异步下载，但不等待结果
  downloadFileAsync(doc).catch(error => {
    console.error('下载失败:', error);
  });
};

/**
 * 异步版本的下载函数
 * @param {Object} doc - 文档对象，包含 file_url 和 title 字段
 * @param {string} doc.file_url - 文件URL
 * @param {string} doc.title - 文档标题
 */
export const downloadFileAsync = async (doc) => {
  console.log('=== 开始下载文件 ===');
  console.log('文档对象:', doc);
  console.log('文档ID:', doc.id);
  
  if (!doc.id) {
    message.warning('文档ID不存在');
    return;
  }
  
  try {
    // 使用后端的统一下载接口，进行权限验证
    const response = await axios.get(`/api/documents/${doc.id}/download/`, {
      responseType: 'blob'
    });
    
    console.log('下载响应状态:', response.status);
    console.log('文件大小:', response.data.size);
    
    // 获取文件名
    const contentDisposition = response.headers['content-disposition'];
    let fileName = doc.title || 'document';
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        fileName = filenameMatch[1].replace(/['"]/g, '');
      }
    }
    
    // 如果没有从header获取到文件名，使用文档标题
    if (!fileName || fileName === 'document') {
      const fileExtension = doc.file_url ? doc.file_url.split('.').pop() : '';
      fileName = doc.title ? `${doc.title}.${fileExtension}` : 'document';
    }
    
    console.log('下载文件名:', fileName);
    
    // 创建下载链接
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.style.display = 'none';
    
    // 添加到DOM并触发点击
    document.body.appendChild(link);
    link.click();
    
    // 清理DOM和URL对象
    setTimeout(() => {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 100);
    
    message.success('开始下载文件');
    console.log('下载链接已触发');
    
  } catch (error) {
    console.error('下载失败:', error);

    const fallbackUrl = getDownloadUrl(doc);
    if (fallbackUrl && fallbackUrl.startsWith('http')) {
      try {
        const directResp = await fetch(fallbackUrl);
        if (directResp.ok) {
          const blob = await directResp.blob();
          const fileName = doc.title || doc.oss_file?.original_name || 'download';
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
          message.success('开始下载文件');
          return;
        }
      } catch (fallbackError) {
        console.error('直链下载失败:', fallbackError);
      }
    }
    
    if (error.response) {
      // 服务器返回错误响应
      if (error.response.status === 403) {
        message.error('没有下载权限');
      } else if (error.response.status === 404) {
        message.error('文件不存在');
      } else {
        message.error(`下载失败: ${error.response.status}`);
      }
    } else {
      // 网络错误或其他错误
      message.error('下载失败，请稍后重试');
    }
  }
};

/**
 * 批量下载文件
 * @param {Array} docs - 文档对象数组
 */
export const downloadFiles = (docs) => {
  if (!docs || docs.length === 0) {
    message.warning('请选择要下载的文档');
    return;
  }
  
  const downloadableDocs = docs.filter(doc => doc.file_url);
  const nonDownloadableCount = docs.length - downloadableDocs.length;
  
  if (downloadableDocs.length === 0) {
    message.warning('您没有权限下载选中的文档或文档没有文件');
    return;
  }
  
  if (nonDownloadableCount > 0) {
    message.info(`开始下载 ${downloadableDocs.length} 个文档，其中 ${nonDownloadableCount} 个文档您没有下载权限`);
  } else {
    message.success(`开始下载 ${downloadableDocs.length} 个文档`);
  }
  
  // 批量下载逻辑
  downloadableDocs.forEach((doc, index) => {
    setTimeout(() => {
      downloadFile(doc);
    }, index * 500); // 每个文件间隔500ms下载，避免浏览器阻止
  });
}; 